// Firebaseの初期化
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./config";

// Firebaseサービスのインポート
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, Timestamp, FieldValue } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const app = initializeApp(firebaseConfig);
// サービスのインスタンス作成
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const fb = app;
export const provider = new GoogleAuthProvider();
// provider.setCustomParameters({
//   prompt: "consent",
//   access_type: "offline", // リフレッシュトークンを取得するために必要
// });
// Firestoreの特定の値
export const FirebaseFieldValue = FieldValue;
export const FirebaseTimestamp = Timestamp;
